// GENERATED FILE — niet handmatig bewerken. Uitvoeren: nx run icons:codegen
import type { IconName } from './icon-names';

import aanwezigheidSvg from '../../../../../../../apps/assets/icons/Aanwezigheid.svg?raw';
import accountSvg from '../../../../../../../apps/assets/icons/Account.svg?raw';
import addSelectieSvg from '../../../../../../../apps/assets/icons/AddSelectie.svg?raw';
import addUserSvg from '../../../../../../../apps/assets/icons/AddUser.svg?raw';
import aiSearchSvg from '../../../../../../../apps/assets/icons/ai-search.svg?raw';
import alertSvg from '../../../../../../../apps/assets/icons/alert.svg?raw';
import arrowDownSvg from '../../../../../../../apps/assets/icons/arrow-down.svg?raw';
import basisvaardighedenSvg from '../../../../../../../apps/assets/icons/Basisvaardigheden.svg?raw';
import bezigSvg from '../../../../../../../apps/assets/icons/Bezig.svg?raw';
import bookmarkSvg from '../../../../../../../apps/assets/icons/Bookmark.svg?raw';
import bookmarkOutlineSvg from '../../../../../../../apps/assets/icons/BookmarkOutline.svg?raw';
import chatHistorySvg from '../../../../../../../apps/assets/icons/ChatHistory.svg?raw';
import checkSvg from '../../../../../../../apps/assets/icons/Check.svg?raw';
import checkboxCheckedSvg from '../../../../../../../apps/assets/icons/Checkbox-Checked.svg?raw';
import checkboxIndeterminateSvg from '../../../../../../../apps/assets/icons/Checkbox-indeterminate.svg?raw';
import checkmarkSvg from '../../../../../../../apps/assets/icons/Checkmark.svg?raw';
import chevronDownSvg from '../../../../../../../apps/assets/icons/ChevronDown.svg?raw';
import chevronDownDoubleSvg from '../../../../../../../apps/assets/icons/ChevronDown-Double.svg?raw';
import chevronLeftSvg from '../../../../../../../apps/assets/icons/ChevronLeft.svg?raw';
import chevronLeftDoubleSvg from '../../../../../../../apps/assets/icons/ChevronLeft-Double.svg?raw';
import chevronRightSvg from '../../../../../../../apps/assets/icons/ChevronRight.svg?raw';
import chevronRightDoubleSvg from '../../../../../../../apps/assets/icons/ChevronRight-Double.svg?raw';
import chevronUpSvg from '../../../../../../../apps/assets/icons/ChevronUp.svg?raw';
import chevronUpDoubleSvg from '../../../../../../../apps/assets/icons/ChevronUp-Double.svg?raw';
import cijfersSvg from '../../../../../../../apps/assets/icons/Cijfers.svg?raw';
import communitySvg from '../../../../../../../apps/assets/icons/Community.svg?raw';
import crownSvg from '../../../../../../../apps/assets/icons/crown.svg?raw';
import deleteSvg from '../../../../../../../apps/assets/icons/Delete.svg?raw';
import detailsSvg from '../../../../../../../apps/assets/icons/Details.svg?raw';
import doorstroomSvg from '../../../../../../../apps/assets/icons/Doorstroom.svg?raw';
import downloadSvg from '../../../../../../../apps/assets/icons/Download.svg?raw';
import editSvg from '../../../../../../../apps/assets/icons/Edit.svg?raw';
import errorSvg from '../../../../../../../apps/assets/icons/Error.svg?raw';
import exportSvg from '../../../../../../../apps/assets/icons/Export.svg?raw';
import favorietSvg from '../../../../../../../apps/assets/icons/Favoriet.svg?raw';
import feedbackSvg from '../../../../../../../apps/assets/icons/Feedback.svg?raw';
import filterSvg from '../../../../../../../apps/assets/icons/Filter.svg?raw';
import folderSvg from '../../../../../../../apps/assets/icons/Folder.svg?raw';
import fullScreenSvg from '../../../../../../../apps/assets/icons/FullScreen.svg?raw';
import fullScreenOffSvg from '../../../../../../../apps/assets/icons/FullScreenOff.svg?raw';
import gebruikerSvg from '../../../../../../../apps/assets/icons/Gebruiker.svg?raw';
import geplandSvg from '../../../../../../../apps/assets/icons/Gepland.svg?raw';
import hamburgerSvg from '../../../../../../../apps/assets/icons/Hamburger.svg?raw';
import helpSvg from '../../../../../../../apps/assets/icons/Help.svg?raw';
import hideSvg from '../../../../../../../apps/assets/icons/Hide.svg?raw';
import historySvg from '../../../../../../../apps/assets/icons/History.svg?raw';
import ideeenbordSvg from '../../../../../../../apps/assets/icons/ideeenbord.svg?raw';
import infoSvg from '../../../../../../../apps/assets/icons/Info.svg?raw';
import instellingenSvg from '../../../../../../../apps/assets/icons/Instellingen.svg?raw';
import kalenderSvg from '../../../../../../../apps/assets/icons/Kalender.svg?raw';
import legendaSvg from '../../../../../../../apps/assets/icons/Legenda.svg?raw';
import linkSvg from '../../../../../../../apps/assets/icons/Link.svg?raw';
import magisterSvg from '../../../../../../../apps/assets/icons/Magister.svg?raw';
import meatballMenuSvg from '../../../../../../../apps/assets/icons/MeatballMenu.svg?raw';
import meatballMenuVerticalSvg from '../../../../../../../apps/assets/icons/MeatballMenuVertical.svg?raw';
import minusSvg from '../../../../../../../apps/assets/icons/minus.svg?raw';
import newPageSvg from '../../../../../../../apps/assets/icons/NewPage.svg?raw';
import pijlLinksBenedenSvg from '../../../../../../../apps/assets/icons/pijl-links-beneden.svg?raw';
import pinnedSvg from '../../../../../../../apps/assets/icons/Pinned.svg?raw';
import prestatieanalyseSvg from '../../../../../../../apps/assets/icons/Prestatieanalyse.svg?raw';
import refreshSvg from '../../../../../../../apps/assets/icons/Refresh.svg?raw';
import releasenotesSvg from '../../../../../../../apps/assets/icons/Releasenotes.svg?raw';
import rolSvg from '../../../../../../../apps/assets/icons/Rol.svg?raw';
import schoolSvg from '../../../../../../../apps/assets/icons/School.svg?raw';
import searchSvg from '../../../../../../../apps/assets/icons/Search.svg?raw';
import settingsSvg from '../../../../../../../apps/assets/icons/Settings.svg?raw';
import shareSvg from '../../../../../../../apps/assets/icons/Share.svg?raw';
import showSvg from '../../../../../../../apps/assets/icons/Show.svg?raw';
import slotSvg from '../../../../../../../apps/assets/icons/Slot.svg?raw';
import sluitenSvg from '../../../../../../../apps/assets/icons/Sluiten.svg?raw';
import somtodaySvg from '../../../../../../../apps/assets/icons/Somtoday.svg?raw';
import sorterenSvg from '../../../../../../../apps/assets/icons/Sorteren.svg?raw';
import sorterenAflopendSvg from '../../../../../../../apps/assets/icons/SorterenAflopend.svg?raw';
import sorterenOplopendSvg from '../../../../../../../apps/assets/icons/SorterenOplopend.svg?raw';
import startpaginaSvg from '../../../../../../../apps/assets/icons/Startpagina.svg?raw';
import supportSvg from '../../../../../../../apps/assets/icons/Support.svg?raw';
import switchSvg from '../../../../../../../apps/assets/icons/Switch.svg?raw';
import thumbDownSvg from '../../../../../../../apps/assets/icons/thumb-down.svg?raw';
import thumbUpSvg from '../../../../../../../apps/assets/icons/thumb-up.svg?raw';
import toevoegenSvg from '../../../../../../../apps/assets/icons/Toevoegen.svg?raw';
import trendSvg from '../../../../../../../apps/assets/icons/Trend.svg?raw';
import uitklappenLinksSvg from '../../../../../../../apps/assets/icons/UitklappenLinks.svg?raw';
import uitklappenRechtsSvg from '../../../../../../../apps/assets/icons/UitklappenRechts.svg?raw';
import uitloggenSvg from '../../../../../../../apps/assets/icons/Uitloggen.svg?raw';
import unPinnedSvg from '../../../../../../../apps/assets/icons/UnPinned.svg?raw';
import unreadSvg from '../../../../../../../apps/assets/icons/unread.svg?raw';
import userSvg from '../../../../../../../apps/assets/icons/User.svg?raw';
import vestigingSvg from '../../../../../../../apps/assets/icons/Vestiging.svg?raw';
import vsoSvg from '../../../../../../../apps/assets/icons/VSO.svg?raw';
import warningSvg from '../../../../../../../apps/assets/icons/Warning.svg?raw';

export const ICON_REGISTRY: Record<IconName, string> = {
	'aanwezigheid': aanwezigheidSvg,
	'account': accountSvg,
	'add-selectie': addSelectieSvg,
	'add-user': addUserSvg,
	'ai-search': aiSearchSvg,
	'alert': alertSvg,
	'arrow-down': arrowDownSvg,
	'basisvaardigheden': basisvaardighedenSvg,
	'bezig': bezigSvg,
	'bookmark': bookmarkSvg,
	'bookmark-outline': bookmarkOutlineSvg,
	'chat-history': chatHistorySvg,
	'check': checkSvg,
	'checkbox-checked': checkboxCheckedSvg,
	'checkbox-indeterminate': checkboxIndeterminateSvg,
	'checkmark': checkmarkSvg,
	'chevron-down': chevronDownSvg,
	'chevron-down-double': chevronDownDoubleSvg,
	'chevron-left': chevronLeftSvg,
	'chevron-left-double': chevronLeftDoubleSvg,
	'chevron-right': chevronRightSvg,
	'chevron-right-double': chevronRightDoubleSvg,
	'chevron-up': chevronUpSvg,
	'chevron-up-double': chevronUpDoubleSvg,
	'cijfers': cijfersSvg,
	'community': communitySvg,
	'crown': crownSvg,
	'delete': deleteSvg,
	'details': detailsSvg,
	'doorstroom': doorstroomSvg,
	'download': downloadSvg,
	'edit': editSvg,
	'error': errorSvg,
	'export': exportSvg,
	'favoriet': favorietSvg,
	'feedback': feedbackSvg,
	'filter': filterSvg,
	'folder': folderSvg,
	'full-screen': fullScreenSvg,
	'full-screen-off': fullScreenOffSvg,
	'gebruiker': gebruikerSvg,
	'gepland': geplandSvg,
	'hamburger': hamburgerSvg,
	'help': helpSvg,
	'hide': hideSvg,
	'history': historySvg,
	'ideeenbord': ideeenbordSvg,
	'info': infoSvg,
	'instellingen': instellingenSvg,
	'kalender': kalenderSvg,
	'legenda': legendaSvg,
	'link': linkSvg,
	'magister': magisterSvg,
	'meatball-menu': meatballMenuSvg,
	'meatball-menu-vertical': meatballMenuVerticalSvg,
	'minus': minusSvg,
	'new-page': newPageSvg,
	'pijl-links-beneden': pijlLinksBenedenSvg,
	'pinned': pinnedSvg,
	'prestatieanalyse': prestatieanalyseSvg,
	'refresh': refreshSvg,
	'releasenotes': releasenotesSvg,
	'rol': rolSvg,
	'school': schoolSvg,
	'search': searchSvg,
	'settings': settingsSvg,
	'share': shareSvg,
	'show': showSvg,
	'slot': slotSvg,
	'sluiten': sluitenSvg,
	'somtoday': somtodaySvg,
	'sorteren': sorterenSvg,
	'sorteren-aflopend': sorterenAflopendSvg,
	'sorteren-oplopend': sorterenOplopendSvg,
	'startpagina': startpaginaSvg,
	'support': supportSvg,
	'switch': switchSvg,
	'thumb-down': thumbDownSvg,
	'thumb-up': thumbUpSvg,
	'toevoegen': toevoegenSvg,
	'trend': trendSvg,
	'uitklappen-links': uitklappenLinksSvg,
	'uitklappen-rechts': uitklappenRechtsSvg,
	'uitloggen': uitloggenSvg,
	'un-pinned': unPinnedSvg,
	'unread': unreadSvg,
	'user': userSvg,
	'vestiging': vestigingSvg,
	'vso': vsoSvg,
	'warning': warningSvg,
};
